import axios from "../axios";

const changeIpAddress = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('/partner/changeIpAddress', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default changeIpAddress;
